import React from 'react';
import classNames from 'classnames';

import classes from './style.module.scss';
export interface TitleProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
  level?: 'h1' | 'h2' | 'h3';
  className?: string;
  children: React.ReactNode;
  id?: string;
}

const Title: React.FC<TitleProps> = ({ level = 'h3', className, children, ...rest }) => {
  switch (level) {
    case 'h1':
      return (
        <h1 className={classNames([classes.title_h1, className])} {...rest}>{children}</h1>
      );
    case 'h2':
      return (
        <h2 className={classNames([classes.title_h2, className])} {...rest}>{children}</h2>
      );
    case 'h3':
      return (
        <h3 className={classNames([classes.title_h3, className])} {...rest}>{children}</h3>
      );
    default:
      return null;
  }
};

export default Title;
